// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import Login from './Login';
import CategoryList from './category/CategoryList';
import ProductList from './product/ProductList';
import OrderList from './order/OrderList';
import SubCategoryList from './subCategory/SubCategoryList';
import DiscountList from './discount/DiscountList';
import VideoList from './Video/Videolist';
import ShipmentList from './Shipment/ShipmentList';
import BannerList from './Banner/BannerList';
import SectionList from './Section/SectionList';
import CreateUser from './CreateUser';
import Dashboard from './Dashboard';
import ContactUS from './contact/ContactList';
import SubcategoryOffer from './Offer/SubcategoryOfferList';

function App() {
  const location = useLocation(); // Correct usage of useLocation within Router context

  return (
    <div>
      {/* Show sidebar on all routes except /login */}
      {location.pathname !== '/login' && <Sidebar />}

      <Routes>
        {/* Redirect the root path to the login page */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/category-list" element={<CategoryList />} />
        <Route path='/sub-category-list' element={<SubCategoryList/>}/>
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/order-list" element={<OrderList />} />
        <Route path='/discount-list' element={<DiscountList/>}/>
        <Route path="/Video-list" element={<VideoList />} />
        <Route path="/Shipment-list" element={<ShipmentList />} />
        <Route path="/Banner-list" element={<BannerList />} />
        <Route path="/Section-list" element={<SectionList />} />
        <Route path="/CreateUser" element={<CreateUser />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Contact-List" element={<ContactUS />} />
        <Route path="/SubcategoryOffer-List" element={<SubcategoryOffer />} />
        {/* Other routes */}
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;